import { actionTypes } from '../index';

// @todo expand this method for getting fetched filtered tariffs, products and the tariff alias
export const setInitialized = (status: boolean, isAddressVerificationOnFirstStep: boolean) => ({
    type: actionTypes.INITIALIZED,
    payload: { status, isAddressVerificationOnFirstStep },
});
